import TiledLevel from "./lib/TiledLevel";
import {Alien, Tile, TilesDefinitions, TilesTypes} from "./Tiles";
import EventManager from "./lib/EventManager";
import {emit, eventSubscriber, on} from "./lib/EventDecorators";
import * as Events from "./Events";

class Level extends eventSubscriber(TiledLevel) {

    greenAlien: Alien
    yellowAlien: Alien
    redAlien: Alien

    selectedAlien: Alien

    completed: boolean = false

    moves: Array<Alien> = []

    get hasMoreThanOneAlien() {
        return this.yellowAlien || this.redAlien
    }

    constructor(options) {
        super(options)
        this.placeAliens()
        this.selectAlien('green')
    }

    placeAliens() {
        this.tiles.forEach( (tile, index) => {
            let x = index % this.columns
            let y = Math.floor(index / this.columns)
            switch ( tile ) {
                case TilesTypes.GREEN_ALIEN:
                    this.greenAlien = { x, y, id: 'green', isDead: false }
                    this.tiles[index] = 0
                    break;
                case TilesTypes.YELLOW_ALIEN:
                    this.yellowAlien = { x, y, id: 'yellow', isDead: false }
                    this.tiles[index] = 0
                    break;
                case TilesTypes.RED_ALIEN:
                    this.redAlien = { x, y, id: 'red', isDead: false }
                    this.tiles[index] = 0
                    break;
                default:
            }
        })
    }

    @on(Events.selectAlien)
    selectAlien(id: string) {
        if (this.selectedAlien?.id !== id) {
            const alienToSelect = this[id + 'Alien'] || this.greenAlien
            if (alienToSelect.isDead) {

            } else {
                this.selectedAlien = this[id + 'Alien'] || this.greenAlien
                this.moves.push({...this.selectedAlien})
                EventManager.emit(Events.glowAlien, this.selectedAlien.id)
            }
        }
    }

    at(column: number, row: number): Tile {
        return TilesDefinitions[super.at(column, row)];
    }

    @on('set-tile')
    @emit('update-tile')
    assign(column: number, row:number, value: number) {
        super.assign(column, row, value);
       /* if (value === TilesTypes.GREEN_ALIEN) {
            this.greenPosition = { x: column, y: row }
        }*/
    }

    @on('move')
    move(direction) {
        let startingCol, startingRow
        let col = startingCol = this.selectedAlien.x
        let row = startingRow = this.selectedAlien.y
        let tile = this.at(this.selectedAlien.x, this.selectedAlien.y)

        const isAlien = (col, row) =>
          (this.greenAlien && this.selectedAlien !== this.greenAlien && this.greenAlien.x === col && this.greenAlien.y === row) ||
          (this.yellowAlien && this.selectedAlien !== this.yellowAlien && this.yellowAlien.x === col && this.yellowAlien.y === row) ||
          (this.redAlien && this.selectedAlien !== this.redAlien && this.redAlien.x === col && this.redAlien.y === row)

        const thereAreNoObstacles = (col, row) => tile.solid === false && tile.deadly === false && !isAlien(col,row)

        switch (direction) {
            case 'right':
                while (thereAreNoObstacles(col, row) && col < this.columns ) {
                    col++
                    tile = this.at(col, row)
                }
                if (tile.deadly) {
                    this.selectedAlien.x = col
                    this.selectedAlien.isDead = true
                    EventManager.emit(Events.killAlien, this.selectedAlien)
                } else {
                    this.selectedAlien.x = col - 1
                }
                break;
            case 'left':
                while (thereAreNoObstacles(col, row) && col > 0  ) {
                    col--
                    tile = this.at(col, row)
                }
                if (tile.solid || isAlien(col, row)) {
                    this.selectedAlien.x = col + 1
                } else {
                    if (tile.deadly) {
                        this.selectedAlien.isDead = true
                        EventManager.emit(Events.killAlien, this.selectedAlien)
                    }
                    this.selectedAlien.x = col
                }
                break;
            case 'up':
                while (thereAreNoObstacles(col, row) && row > 0  ) {
                    row--
                    tile = this.at(col, row)
                }
                if (tile.solid || isAlien(col, row)) {
                    this.selectedAlien.y = row + 1
                } else {
                    if (tile.deadly) {
                        this.selectedAlien.isDead = true
                        EventManager.emit(Events.killAlien, this.selectedAlien)
                    }
                    this.selectedAlien.y = row
                }
                break;
            case 'down':
                while (thereAreNoObstacles(col, row) &&  row < this.rows - 1  ) {
                    row++
                    tile = this.at(col, row)
                }
                if (tile.deadly) {
                    this.selectedAlien.y = row
                    this.selectedAlien.isDead = true
                    EventManager.emit(Events.killAlien, this.selectedAlien)
                } else {
                    this.selectedAlien.y = row - 1
                }
                break;
        }
        if (this.selectedAlien.y !== startingRow || this.selectedAlien.x !== startingCol) {
            this.moves.push({...this.selectedAlien})
            if (!!this.at(this.selectedAlien.x, this.selectedAlien.y).exit) {
                EventManager.emit(Events.levelCompleted)
                this.completed = true
            }
            EventManager.emit(Events.updateAlienPosition, this.selectedAlien)
        }
    }

    @on('undo')
    undo () {
        if (this.moves.length > 1) {
            const pop = this.moves.pop()
            const move = this.moves[this.moves.length - 1]

            this.selectedAlien = this[move.id + 'Alien'] || this.greenAlien

            this.selectedAlien.x = move.x
            this.selectedAlien.y = move.y
            this.selectedAlien.isDead = move.isDead

            if (pop.id !== move.id) { // is a selection
                EventManager.emit(Events.glowAlien, move.id)
            } else {
                EventManager.emit(Events.updateAlienPosition, this.selectedAlien)
            }
        }
    }

}

export default Level;
